module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAATRJREFUSEvtlLFKBDEURc9FBf2DLSy08CMsBJG1EgTBYrEVrfwbKxFWsLBQC0WsLUTsrRUELfwI8UogK2OcyczOuoXglJnHOcl9eRFj/jRmPv+C2oR/JSLbgXME3Ek6LFpHFkT4CdCL4N2iZCSB7QngGNhKstqW1A9rrQURfgZsJPBHYEnSW2uB7UngtA7eShDhF8BabueDf6UR2V4BbiS5CLE9BZwD603gpSewvQMcRFBP0kcojPBrYDWBPwOLg8zTwfh2Att7wH6h6BLYBMJtuaqAh4a+Vk3cl8D2NPAALCTFATwDdJP1J2A5B/8Rke0OcA/M1bwBIZbsziubbHsWuM1IGsMrr2lGMhQ8OwclkqHhtYMWJaEn700zz17Tssbang8CSS+1j39JQevHrqns7ws+AQRWahkvZT2MAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/check-bold.png
// module id = bWk/
// module chunks = 0